import { mergeClassnames } from '@heathmont/moon-core-tw';

type Props = {
  position?: number;
  points?: string;
  center?: boolean;
  isMyScore?: boolean;
};

const Points: React.FC<Props> = ({ points, center = true, isMyScore }) => (
  <p
    className={mergeClassnames(
      'm-0 place-self-center justify-self-end text-moon-12 font-medium text-trunks',
      center && 'justify-self-center',
      isMyScore && 'text-bulma',
    )}
  >
    {points}
  </p>
);

export default Points;
